import lozad from 'lozad';

// lazy load rest of images
const observer = lozad('.lozad', {
    load(el) {
        // Custom implementation to load an element
        el.src = el.getAttribute('data-src');
    },
});

export default observer;



// WEBPACK FOOTER //
// ./src/js/methods/lozad.js